import styled from 'styled-components';

export const ScrollContainer = styled.div`
  flex: 1;
  overflow: auto;
`;

export const Container = styled.div<{ isPortrait: boolean }>`
  margin: 0 auto;
  padding: 20px;
  width: ${(props) => (props.isPortrait ? '794px' : '1123px')};
`;

export const Wrapper = styled.div`
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.2);
`;

export const Page = styled.div<{ isEditingMode: boolean }>`
  position: relative;
  height: 100%;
  width: 100%;

  .panda-spinner-container {
    position: fixed;
  }

  ${(props) =>
    props.isEditingMode
      ? `
      padding-right: 12px;

      &::after {
        background-size: 10px 10px;
        background-image: linear-gradient(to right, #f1f1f1 1px, transparent 1px),
          linear-gradient(to bottom, #f1f1f1 1px, transparent 1px);
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: 0;
        content: ' ';
        -webkit-transition: opacity 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        -moz-transition: opacity 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        -o-transition: opacity 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        transition: opacity 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        z-index: -1;
      }

      &:hover::after {
        opacity: 1;
      }

      .treelab-space-view {
        border: 2px solid transparent;
        transition: border-color 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        -webkit-transition: border-color 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        -moz-transition: border-color 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
        -o-transition: border-color 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
      }
      .treelab-space-view--absent {
        opacity: 0;
        transition: opacity 350ms cubic-bezier(0.25, 0.25, 0, 1.03);
      }
      &:hover {
        .treelab-space-view {
          cursor: pointer !important;
          border: 2px solid rgba(0, 0, 0, 0.2);
        }
        .treelab-space-view--absent {
          opacity: 1;
        }
      }
    `
      : ''}
`;
